module.exports = __webpack_public_path__ + "img/aak.41d55de4.png";